module.exports = __webpack_public_path__ + "static/img/kb-card-app-contents-02-img-01@t.ca3cfeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-app-contents-02-img-01@t.png
// module id = ZuBq
// module chunks = 0